import PublicationListContainer from "@/components/business/PublicationListContainer/PublicationListContainer";
import { useChangeBackgroundColor } from "@hooks/useChangeBackgroundColor";
import { theme } from "@styles/theme";
import { removeDealTypeDisplayName } from "@utils/returnDealTypeDisplayName/returnDealTypeDisplayName";

const PublicationListPage = () => {
  useChangeBackgroundColor(theme.color.neural.gray00);

  removeDealTypeDisplayName();

  return <PublicationListContainer />;
};

export default PublicationListPage;
